import React, { useEffect, useState } from 'react';
import { Toaster } from '../ui/sonner';
import { TOKEN_KEY } from './adminApi';
import { AdminLogin } from './AdminLogin';
import { AdminDashboard } from './AdminDashboard';

export default function AdminPage() {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));

  useEffect(() => { document.title = 'Admin | 3D Printer Gear'; }, []);

  const handleLogin = (newToken) => {
    localStorage.setItem(TOKEN_KEY, newToken);
    setToken(newToken);
  };

  const handleLogout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
  };

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900" data-testid="admin-page">
      {token ? <AdminDashboard token={token} onLogout={handleLogout} /> : <AdminLogin onLogin={handleLogin} />}
      <Toaster position="top-right" />
    </div>
  );
}
